import DoAPICall from './DoAPICall'

//Create Mno Credential
    export async function createSMSChannelCredential(userToken, smsChannelCredentials){
        const apiPayload = {
            httpMethod:'post',
            userToken,
            uri:'smschannelcredentials',
            payLoad:{
                description:smsChannelCredentials.description,
                channel_id:smsChannelCredentials.channel_id,
                keyValue:smsChannelCredentials.keyValue,
                key:smsChannelCredentials.key,
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get All Mno Credential
    export async function getSMSChannelCredentials(userToken){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'smschannelcredentials',
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get One Mno Credential
    export async function getSMSChannelCredential(userToken, id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'smschannelcredentials/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get Payments Providers of client
export async function getCredentialsOfChannel(userToken,channel_id){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'credentialsofsmschannel/'+channel_id,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Update Mno Credential
    export async function updateSMSChannelCredentials(userToken, smsChannelCredentials){
        const apiPayload = {
            httpMethod:'put',
            userToken,
            uri:'smschannelcredentials/'+smsChannelCredentials.id,
            payLoad:{
                keyValue:smsChannelCredentials.keyValue,
                description:smsChannelCredentials.description,
                key:smsChannelCredentials.key
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Delete Mno Credential
    export async function deleteSMSChannelCredential(userToken, id){
        const apiPayload = {
            httpMethod:'delete',
            userToken,
            uri:'smschannelcredentials/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }
